var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _rect7, _path3, _rect8, _path4, _rect9, _path5, _rect0, _path6, _rect1, _path7, _rect10, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect11, _path32, _polygon, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrorIllustrationMoonlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1220.69 605.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f2e41;}.cls-2,.cls-5{fill:#f2f2f2;}.cls-3{fill:#3f3d56;}.cls-4{fill:#9c8ffd;}.cls-5,.cls-7{opacity:0.1;isolation:isolate;}.cls-6{fill:#ff6584;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trello_powerup_Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.35,0C274.85,0,2.59,270.68,0,605.56H1220.69C1218.1,270.68,945.84,0,610.35,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 578.82,
    cy: 63.26,
    r: 6.02
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 389.81,
    cy: 261.9,
    r: 2.41
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 744.96,
    cy: 375.07,
    r: 2.41
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 117.73,
    cy: 344.97,
    r: 2.41
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1056.77,
    cy: 259.49,
    r: 2.41
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 283.86,
    cy: 284.77,
    r: 2.41
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 678.74,
    cy: 236.62,
    r: 2.41
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 758.2,
    cy: 63.26,
    r: 2.41
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 254.97,
    y: 347.38,
    width: 2.41,
    height: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 326,
    y: 163.18,
    width: 2.41,
    height: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 499.36,
    y: 300.43,
    width: 2.41,
    height: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 959.25,
    y: 353.4,
    width: 2.41,
    height: 1.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 815.99,
    y: 169.2,
    width: 2.41,
    height: 1.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 270.98,
    y: 437.83,
    width: 4.24,
    height: 167.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.32,408.6c.27,58.51-40.9,106.14-40.9,106.14S231.81,467.49,231.54,409s40.9-106.15,40.9-106.15S314.05,350.08,314.32,408.6Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 217.44,
    y: 388.22,
    width: 5.49,
    height: 216.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.62,365.31c.35,75.86-53,137.61-53,137.61S166.65,441.67,166.3,365.8s53-137.61,53-137.61S273.27,289.44,273.62,365.31Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 857.28,
    y: 437.83,
    width: 4.24,
    height: 167.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M900.62,459.16c.27,58.52-40.9,106.14-40.9,106.14s-41.61-47.24-41.88-105.76,40.9-106.14,40.9-106.14S900.35,400.64,900.62,459.16Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 169.86,
    y: 437.83,
    width: 4.24,
    height: 167.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.19,408.6c.27,58.51-40.9,106.14-40.9,106.14S130.69,467.49,130.42,409s40.9-106.15,40.9-106.15S212.92,350.08,213.19,408.6Z"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 543.06,
    y: 437.83,
    width: 4.24,
    height: 167.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M586.4,408.6c.27,58.51-40.9,106.14-40.9,106.14S503.89,467.49,503.62,409s40.9-106.15,40.9-106.15S586.13,350.08,586.4,408.6Z"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 489.52,
    y: 388.22,
    width: 5.49,
    height: 216.96
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M545.7,365.31c.35,75.86-53,137.61-53,137.61s-53.94-61.25-54.29-137.12,53-137.61,53-137.61S545.35,289.44,545.7,365.31Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 441.94,
    y: 437.83,
    width: 4.24,
    height: 167.35
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M485.27,408.6c.27,58.51-40.9,106.14-40.9,106.14S402.77,467.49,402.5,409s40.9-106.15,40.9-106.15S485,350.08,485.27,408.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M888.91,515.77l-70.79-65.1c-.19,2.93-.29,5.88-.28,8.87.27,58.52,41.88,105.76,41.88,105.76A196,196,0,0,0,888.91,515.77Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.94,590.25c2.43,9,10.74,14.52,10.74,14.52s4.37-9,1.95-17.95-10.74-14.52-10.74-14.52S359.52,581.28,361.94,590.25Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365.51,588.32c6.65,6.48,7.47,16.44,7.47,16.44s-10-.54-16.64-7-7.47-16.44-7.47-16.44S358.85,581.84,365.51,588.32Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M703.85,590.25c2.43,9,10.73,14.52,10.73,14.52s4.38-9,1.95-17.95S705.8,572.3,705.8,572.3,701.43,581.28,703.85,590.25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M707.41,588.32c6.66,6.48,7.47,16.44,7.47,16.44s-10-.54-16.63-7-7.47-16.44-7.47-16.44S700.76,581.84,707.41,588.32Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.27,590.25c2.43,9,10.73,14.52,10.73,14.52s4.38-9,2-17.95S94.22,572.3,94.22,572.3,89.85,581.28,92.27,590.25Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.84,588.32c6.65,6.48,7.46,16.44,7.46,16.44s-10-.54-16.63-7S79.2,581.3,79.2,581.3,89.18,581.84,95.84,588.32Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M466.31,265.71,582.5,441.07a137.16,137.16,0,0,0,3.9-32.47c-.13-28.54-10.09-54.39-20.26-73.39l-5.38,1.33,5.06-1.93a186.84,186.84,0,0,0-21.3-31.78s-3,3.43-7.29,9.58c-15.27-49.51-45.82-84.22-45.82-84.22A237.85,237.85,0,0,0,466.31,265.71Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1134.81,598.08a3.47,3.47,0,1,0,0-6.93h-28.48a7.76,7.76,0,0,1-3.46,10.4,3.46,3.46,0,0,0,3.46,3.46h28.48a3.47,3.47,0,1,0,0-6.93Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1067.11,590.93c.49,18.9-10.94,14.08-24.79,14.08s-25.28,2.41-25.38-14.08c0-8.11,11.32-9.88,25.17-9.88S1066.9,582.82,1067.11,590.93Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1099.52,598.4a2,2,0,0,0-.71-.23,35.83,35.83,0,0,1-3.73-.8,7.75,7.75,0,0,1-3.31-1.84,8.11,8.11,0,0,0-1.16-1.11,1.42,1.42,0,0,0-1.52-.11l-.13.13-.52-.34c-.91-.61-1.84-1.2-2.76-1.79l0,0a1.09,1.09,0,0,0,0-.44,2.11,2.11,0,0,0-.92-1.14,35.47,35.47,0,0,0,3.58-.25,4.3,4.3,0,0,0,3-1.18.9.9,0,0,0,.21-.5c0-.37-.39-.61-.73-.76a7.83,7.83,0,0,0-1.43-.42,8.62,8.62,0,0,1-1-.21,5.18,5.18,0,0,1-.86-.4l-1.76-1a3.28,3.28,0,0,1-.69-.48c-.3-.31-.43-.76-.73-1.07s-1.42-.67-1.59-.08c-.06.23.19.49.22.75a12.24,12.24,0,0,0-1.23-.67,1.19,1.19,0,0,0,.08-.16,15.59,15.59,0,0,1-4.53-5.86l.52,0a1.4,1.4,0,0,0,.85-.21.93.93,0,0,0,.3-.75,2.53,2.53,0,0,0-.2-.81,6.2,6.2,0,0,0-1.17-2.1,6.9,6.9,0,0,0-1.72-1.22l-.1-.06c0-.13-.08-.26-.13-.39a20.64,20.64,0,0,0-1.29-2.29,14.84,14.84,0,0,1-1.47-3.92,5.2,5.2,0,0,0-.93-2.31c-.92-1-2.5-1-3.86-.83-.77.09-1.54.2-2.31.32l0-.06a1.51,1.51,0,0,1-.18-.58,2.68,2.68,0,0,1,.11-.49,1.2,1.2,0,0,0-.33-1.11l-.1-.1a6.37,6.37,0,0,0,.23-.61.73.73,0,0,0,.17-.55,5.51,5.51,0,0,0,.22-1.51,17,17,0,0,1-.12-3.42,1.91,1.91,0,0,0-.3-.79.48.48,0,0,0-.11-.09,5.37,5.37,0,0,1,.81-.84,11.7,11.7,0,0,1,1.9-1.2c.16-.09.38-.15.53-.25a5.69,5.69,0,0,0,.71.07,5.4,5.4,0,0,0,5.07-7.37,1.93,1.93,0,0,0,1.18-.87,3.64,3.64,0,0,0,.46-1.5,1.57,1.57,0,0,0-.23-1.19,2.38,2.38,0,0,0-.69-.48,2.75,2.75,0,0,1-.86-.87c-.15-.25-.26-.53-.39-.79a3,3,0,0,0-2.52-1.67,12.44,12.44,0,0,0-1.5.3c-1.68.3-3.52-.59-5.08.1a5,5,0,0,0-1.06.71c-.44.36-.87.75-1.27,1.15a2.74,2.74,0,0,0-.78,1.12c-.21.8.3,1.69,0,2.45a3.65,3.65,0,0,1-.4.62c-.35.52,0,2.55,0,3.18a1.17,1.17,0,0,0,.21.87.61.61,0,0,0,.16.12,71.1,71.1,0,0,0-7.68,3.27,16.42,16.42,0,0,0-7.13,6.65c-.42.83-.74,1.7-1.12,2.55-.51,1.12-1.13,2.2-1.75,3.27-.75,1.31-1.5,2.62-2.37,3.85a20.26,20.26,0,0,0-1.38,2c0,.1,0,.2,0,.31a.49.49,0,0,1,0,.29.45.45,0,0,1-.33.19l0,.05a18.13,18.13,0,0,0-.48,1.93c-.26,1-.67,2-.83,3.08a.82.82,0,0,0,.8,1.28c.9.4,1.77.87,2.64,1.35,0,.06,0,.12,0,.19a3.56,3.56,0,0,0,1.88,3.29,9.77,9.77,0,0,0,3.85,1l1.56.15a10.59,10.59,0,0,0,2.4,1,2.82,2.82,0,0,0,.57.09,1.7,1.7,0,0,0,1.28-.73,88.54,88.54,0,0,0,13.43-.27,4.9,4.9,0,0,1,3.63.56c1,.79,1.16,2.18,1.88,3.2a11.79,11.79,0,0,0,1.75,1.71,26.28,26.28,0,0,1,3.36,4.42,10,10,0,0,0,4,3.74,2.93,2.93,0,0,1,1.26-1.1l.39-.25a5.91,5.91,0,0,0,.62.8c.17.18.34.38.5.58h0c-.24,0-.31.33-.34.57-.1.9-.21,1.8-.31,2.71a1,1,0,0,0,0,.53.9.9,0,0,0,.48.4,7.16,7.16,0,0,0,2.67.71c.47,0,.94,0,1.4.06a17.52,17.52,0,0,1,2.27.45,21,21,0,0,0,6.17.48,4.06,4.06,0,0,0,1.25-.23,3.77,3.77,0,0,0,1.24-1,3.52,3.52,0,0,0,.93-1.49A1.45,1.45,0,0,0,1099.52,598.4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1066.22,537.92a5.63,5.63,0,0,0,.59-.14,4.29,4.29,0,0,0-1.88.19A5.58,5.58,0,0,0,1066.22,537.92Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1070.24,539.29c.13.26.24.54.39.79a2.75,2.75,0,0,0,.86.87,2.38,2.38,0,0,1,.69.48,1.61,1.61,0,0,1,.23,1.19,3.64,3.64,0,0,1-.46,1.5,2,2,0,0,1-1.18.87,5.31,5.31,0,0,1-2.83,7,5.23,5.23,0,0,1-3,.35c-.15.1-.37.16-.53.25a11.7,11.7,0,0,0-1.9,1.2,5.37,5.37,0,0,0-.81.84s.08,0,.11.09a1.91,1.91,0,0,1,.3.79,16.3,16.3,0,0,0,.12,3.42,5.51,5.51,0,0,1-.22,1.51.73.73,0,0,1-.17.55c-.07.21-.15.41-.23.61l.09.1a1.18,1.18,0,0,1,.34,1.11,2.68,2.68,0,0,0-.11.49,1.51,1.51,0,0,0,.18.58l0,.06c.77-.12,1.54-.23,2.31-.32a11.11,11.11,0,0,1,1.15-.08.93.93,0,0,1-.05-.24,2.68,2.68,0,0,1,.11-.49,1.2,1.2,0,0,0-.33-1.11l-.1-.1a6.37,6.37,0,0,0,.23-.61.73.73,0,0,0,.17-.55,5.51,5.51,0,0,0,.22-1.51,17,17,0,0,1-.12-3.42,1.91,1.91,0,0,0-.3-.79.48.48,0,0,0-.11-.09,5.37,5.37,0,0,1,.81-.84,11.7,11.7,0,0,1,1.9-1.2c.16-.09.38-.15.53-.25a5.69,5.69,0,0,0,.71.07,5.4,5.4,0,0,0,5.07-7.37,1.93,1.93,0,0,0,1.18-.87,3.64,3.64,0,0,0,.46-1.5,1.57,1.57,0,0,0-.23-1.19,2.38,2.38,0,0,0-.69-.48,2.75,2.75,0,0,1-.86-.87c-.15-.25-.26-.53-.39-.79a2.92,2.92,0,0,0-2.52-1.66,10.74,10.74,0,0,0-1.5.29,3.82,3.82,0,0,1-.83.06A3.47,3.47,0,0,1,1070.24,539.29Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1099.52,598.4a2,2,0,0,0-.71-.23,35.83,35.83,0,0,1-3.73-.8,7.75,7.75,0,0,1-3.31-1.84,8.11,8.11,0,0,0-1.16-1.11,1.42,1.42,0,0,0-1.52-.11l-.13.13-.52-.34c-.91-.61-1.84-1.2-2.76-1.79l0,0a1.09,1.09,0,0,0,0-.44,2.11,2.11,0,0,0-.92-1.14,35.47,35.47,0,0,0,3.58-.25,4.3,4.3,0,0,0,3-1.18.9.9,0,0,0,.21-.5c0-.37-.39-.61-.73-.76a7.83,7.83,0,0,0-1.43-.42,8.62,8.62,0,0,1-1-.21,5.18,5.18,0,0,1-.86-.4l-1.76-1a3.28,3.28,0,0,1-.69-.48c-.3-.31-.43-.76-.73-1.07s-1.42-.67-1.59-.08c-.06.23.19.49.22.75a12.24,12.24,0,0,0-1.23-.67,1.19,1.19,0,0,0,.08-.16,15.59,15.59,0,0,1-4.53-5.86l.52,0a1.4,1.4,0,0,0,.85-.21.93.93,0,0,0,.3-.75,2.53,2.53,0,0,0-.2-.81,6.2,6.2,0,0,0-1.17-2.1,6.9,6.9,0,0,0-1.72-1.22l-.1-.06c0-.13-.08-.26-.13-.39a20.64,20.64,0,0,0-1.29-2.29,14.84,14.84,0,0,1-1.47-3.92,5.2,5.2,0,0,0-.93-2.31c-.92-1-2.5-1-3.86-.83-.3,0-.6.08-.9.13a2.54,2.54,0,0,1,1.15.7,5.08,5.08,0,0,1,.92,2.31,15.22,15.22,0,0,0,1.48,3.92,22.3,22.3,0,0,1,1.28,2.29,3,3,0,0,1,.14.39l.1.06a6.9,6.9,0,0,1,1.72,1.22,6.2,6.2,0,0,1,1.17,2.1,2.53,2.53,0,0,1,.2.81.93.93,0,0,1-.3.75,1.4,1.4,0,0,1-.85.21l-.52,0a15.66,15.66,0,0,0,4.52,5.86c0,.06,0,.1-.07.16a11.09,11.09,0,0,1,1.22.67c0-.26-.27-.52-.21-.75.17-.59,1.3-.21,1.58.08s.44.76.74,1.07a2.83,2.83,0,0,0,.69.48l1.76,1a5.48,5.48,0,0,0,.85.4,8.78,8.78,0,0,0,1,.21,8.07,8.07,0,0,1,1.43.42c.34.15.73.39.73.76a.85.85,0,0,1-.22.5,4.28,4.28,0,0,1-3,1.18,35.47,35.47,0,0,1-3.58.25,2.16,2.16,0,0,1,.92,1.14,1.09,1.09,0,0,1,0,.44l0,0c.92.59,1.84,1.18,2.76,1.79l.52.34.13-.13a1.42,1.42,0,0,1,1.52.11,8.11,8.11,0,0,1,1.16,1.11,7.77,7.77,0,0,0,3.3,1.84,36.58,36.58,0,0,0,3.74.8,2,2,0,0,1,.71.23,1.45,1.45,0,0,1,.54,1.57,3.52,3.52,0,0,1-.93,1.49,3.77,3.77,0,0,1-1.24,1,3.15,3.15,0,0,1-.92.2,21.13,21.13,0,0,0,3.28,0,4.06,4.06,0,0,0,1.25-.23,3.77,3.77,0,0,0,1.24-1,3.52,3.52,0,0,0,.93-1.49A1.44,1.44,0,0,0,1099.52,598.4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1079.5,595.39c.06.05.11.11.18.16l-.14-.19Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1133.27,585.38c0,12.76-5.68,9.24-12.7,9.24s-12.7,3.52-12.7-9.24,12.7-37,12.7-37S1133.27,572.62,1133.27,585.38Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1126.35,590.26c0,5.8-2.59,4.2-5.78,4.2s-5.77,1.6-5.77-4.2,5.77-16.8,5.77-16.8S1126.35,584.46,1126.35,590.26Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1136.49,551.3s2.64-2.75,2.59-5.44"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1109.45,528.43s-1.1-3.64-3.47-4.91"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1083,479.07s-1.1-3.64-3.47-4.91"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1114.27,545.29s-1.11-3.65-3.48-4.92"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1110.65,486.3s-1.1-3.65-3.47-4.92"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1103.43,508s-1.1-3.65-3.47-4.92"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1134.09,588.62s2.63-2.75,2.58-5.44"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1138.9,568.15s2.64-2.74,2.59-5.43"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1076.45,
    y: 569.5,
    width: 30.46,
    height: 1.2,
    transform: "translate(-124.26 374.47) rotate(-18.43)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1103.84,565.86c1.08,4.24-.74,3.23-2.4,3.57s-1.33,1.87-3.62-2.33c-1.58-2.9.74-3.22,2.4-3.57S1103.1,563,1103.84,565.86Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "691.91 334.63 691.91 334.63 691.91 334.63 665.64 310.48 665.41 310.54 654.89 300.97 654.38 300.83 654.93 300.62 543.06 197.76 543.06 197.76 435.03 98.43 379.98 127.63 375.48 128.63 441.45 228.19 691.12 605.01 985.98 605.01 691.91 334.63"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 403.05,
    cy: 111.41,
    r: 32.51
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorIllustrationMoonlight);
export default __webpack_public_path__ + "static/media/mirror_illustration_moonlight.2855dbb2a14bfedc84a50bdfa0d75dfe.svg";
export { ForwardRef as ReactComponent };